import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { map, retry, switchMap, takeWhile } from 'rxjs/operators';
import { ConnectionAutomationService } from './connection-automation.service';
import { ConnectionInfo, ConnectionState } from './models/get-connection-response.model';

@Injectable({
    providedIn: 'root',
})
export class ConnectionPollingService {
    private readonly defaultPollingIntervalMs = 3000;

    public constructor(private readonly connectionAutomationService: ConnectionAutomationService) {}

    public pollConnectionState(
        connectionId: string,
        intervalMs: number = this.defaultPollingIntervalMs,
    ): Observable<ConnectionState> {
        return this.pollConnection(connectionId, intervalMs).pipe(map((connection) => connection.state));
    }

    public pollConnection(
        connectionId: string,
        intervalMs: number = this.defaultPollingIntervalMs,
    ): Observable<ConnectionInfo> {
        return timer(0, intervalMs).pipe(
            switchMap(() => this.connectionAutomationService.getConnection(connectionId)),
            map((connection) => connection.connection),
            retry({ count: 5, delay: (_, retryCount) => timer(2 ** retryCount * 1000) }),
            takeWhile((connection) => connection.state === ConnectionState.Pending, true),
        );
    }
}
